import { render, staticRenderFns } from "./ToggleComponent.vue?vue&type=template&id=33a01d89&scoped=true"
import script from "./ToggleComponent.vue?vue&type=script&lang=js"
export * from "./ToggleComponent.vue?vue&type=script&lang=js"
import style0 from "./ToggleComponent.vue?vue&type=style&index=0&id=33a01d89&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a01d89",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33a01d89')) {
      api.createRecord('33a01d89', component.options)
    } else {
      api.reload('33a01d89', component.options)
    }
    module.hot.accept("./ToggleComponent.vue?vue&type=template&id=33a01d89&scoped=true", function () {
      api.rerender('33a01d89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ToggleComponent.vue"
export default component.exports